module.exports = __webpack_public_path__ + "media/images/current-location-active-6fd187742dd8fff01982968bfb74c266.png";